import { Box, CssBaseline, ThemeProvider, useMediaQuery } from "@mui/material";
import Feedback from "components/common/Feedback";
import {
  fetchCorpFilterCategories,
  fetchCorpSavedFilters,
  setDefaultAPiCalled,
  setLoader
} from "components/common/Filters/Filters.slice";
import { HandleApiFailure } from "components/common/HandleApiFailure";
import ImpersonateBanner from "components/features/ImpersonateUser/Banner";
import CorpWizard from "components/features/Login/CorpWizard";
import NavBar from "components/features/Navbar";
import Onboarding from "components/features/Onboarding";
import SessionTimeout from "components/features/SessionTimeout";
import PreferredEmailDialog from "components/features/dashboard/PreferredEmailDialog";
import { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { theme as MUITheme } from "../../styles/Theme";
import ThemeContext from "./Context";
import ErroBoundryRoute from "./ErrorBoundryRoute";
import Loader from "./Loader";
import "./Main.scss";

const Main = () => {
  const isMobileScreen = useMediaQuery(MUITheme.breakpoints.down("md"));
  const contextValue = useMemo(() => ({ isMobileScreen }), [isMobileScreen]);
  const dispatch = useAppDispatch();
  const isImpersonated = useAppSelector((state: any) => state.app.impersonationDetails.isImpersonated);
  const isStatus = useAppSelector((state) => state.filters?.isStatus);
  const defaultFilter = useAppSelector((state) => state.filters?.savedFilter?.default);
  const isAdmin = useAppSelector((state) => state.app.isAdmin);
  const isSmeUser = useAppSelector((state) => state.app.isSmeUser);
  const isSmeUserFetched: any = useAppSelector((state) => state.app.isSmeUserFetched);

  useEffect(() => {
    if (isSmeUserFetched) {
      (async () => {
        if (isAdmin) {
          dispatch(setLoader(true));
          const filters = ["default", "dynamic", "static", "bookmarked"];
          await dispatch(fetchCorpFilterCategories({}));
          if (isSmeUser) filters.push("consultant");
          await dispatch(fetchCorpSavedFilters({ types: filters }));
          dispatch(setDefaultAPiCalled());
        }
      })();
    }
  }, [isAdmin, isSmeUser, isSmeUserFetched]);

  return (
    <ThemeContext.Provider value={contextValue}>
      <ThemeProvider theme={MUITheme}>
        <div className="App">
          <Onboarding />
          {isStatus && defaultFilter?.length === 0 && <CorpWizard />}
          <Box>
            <CssBaseline />
            {isImpersonated && <ImpersonateBanner />}
            <NavBar />
            <Feedback form="apiFailure" />
            <HandleApiFailure />
            <PreferredEmailDialog />
            <ErroBoundryRoute />
          </Box>
        </div>
        <SessionTimeout />
        <Loader />
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default Main;
